import { cn } from "@/modules/lib/utils"
import { type EventType } from "@modules/calendar/calendarTypes"
import { Text } from "@/components/ui/baseUi/text"

type DefaultCalendarEventProps = {
  index: number
  event: EventType
  displayDetailedEvents: boolean
} & React.ComponentProps<"div">

export function DefaultCalendarEvent({
  index,
  event,
  displayDetailedEvents,
  className,
  ...props
}: DefaultCalendarEventProps) {
  const { title, content } = event

  return (
    <div key={index} className={cn("border-bottom-1 flex flex-col gap-2 p-2", className)} {...props}>
      <Text fontStyle="TM">{title}</Text>
      {displayDetailedEvents && <Text fontStyle="TS">{content}</Text>}
    </div>
  )
}
